/**
 * Căutarea din liste: text scris repede, fără diacritice, în orice ordine.
 *
 * Normalizarea de aici e separată de cea din `prices.ts`, deși seamănă. Aceea
 * face cheia sub care se adună un produs și trebuie să rămână neschimbată cât
 * timp există baza — dacă s-ar schimba, istoricul de prețuri s-ar rupe în două.
 * Asta poate deveni mai deșteaptă oricând, fără să strice nimic.
 */

/** Textul redus la ce contează pentru potrivire: litere mici, fără diacritice. */
export function searchable(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Potrivire pe cuvinte, nu pe șir întreg: „brasov hvac" găsește „Echipamente
 * HVAC – bloc P+4 · Brașov", deși cuvintele nu stau lipite și n-au diacritice.
 *
 * Toate cuvintele căutate trebuie să apară. Altfel al doilea cuvânt ar lărgi
 * căutarea în loc s-o strângă, și cu cât scrii mai mult ai găsi mai multe.
 */
export function matches(text: string, query: string): boolean {
  const cuvinte = searchable(query).split(' ').filter(Boolean);
  if (!cuvinte.length) return true;
  const unde = searchable(text);
  return cuvinte.every((c) => unde.includes(c));
}
